module.exports = __webpack_public_path__ + "media/images/healthcare-policy-navigator-12118f5899b9bcb10fdd3ec7edea97c6.svg";